import { createFileRoute } from "@tanstack/react-router";
import { BottomNav } from "@/components/BottomNav";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Mail, MessageCircle, Phone } from "lucide-react";
import { toast } from "sonner";

export const Route = createFileRoute("/contact")({
  head: () => ({
    meta: [
      { title: "Contact Us — PataTasks" },
      { name: "description", content: "Get in touch with PataTasks support." },
    ],
  }),
  component: ContactPage,
});

function ContactPage() {
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    toast.success("Message sent! We will get back to you soon.");
  };

  return (
    <div className="bg-background min-h-screen pb-20 md:pb-0">
      <main className="mx-auto max-w-3xl px-4 py-10">
        <h1 className="text-2xl sm:text-3xl font-bold tracking-tight text-foreground mb-6">
          Contact Us
        </h1>
        <div className="grid gap-6 sm:grid-cols-3 mb-8">
          <div className="rounded-2xl border border-blue-200 bg-white p-5 text-center shadow-sm">
            <Mail className="mx-auto mb-3 h-8 w-8 text-blue-600" />
            <p className="text-sm font-semibold">Email</p>
            <p className="text-xs text-slate-600">support@patatasks.app</p>
          </div>
          <div className="rounded-2xl border border-blue-200 bg-white p-5 text-center shadow-sm">
            <Phone className="mx-auto mb-3 h-8 w-8 text-blue-600" />
            <p className="text-sm font-semibold">Phone</p>
            <p className="text-xs text-slate-600">+254 700 000 000</p>
          </div>
          <div className="rounded-2xl border border-blue-200 bg-white p-5 text-center shadow-sm">
            <MessageCircle className="mx-auto mb-3 h-8 w-8 text-blue-600" />
            <p className="text-sm font-semibold">WhatsApp</p>
            <p className="text-xs text-slate-600">+254 700 000 000</p>
          </div>
        </div>

        <form
          onSubmit={handleSubmit}
          className="rounded-3xl border border-blue-200 bg-white p-6 shadow-sm space-y-4"
        >
          <div>
            <Label htmlFor="name">Full Name</Label>
            <Input id="name" required placeholder="John Kamau" />
          </div>
          <div>
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" required placeholder="john@example.com" />
          </div>
          <div>
            <Label htmlFor="message">Message</Label>
            <Textarea
              id="message"
              required
              placeholder="How can we help?"
              className="min-h-[120px]"
            />
          </div>
          <Button type="submit" className="w-full">
            Send Message
          </Button>
        </form>
      </main>
      <BottomNav />
    </div>
  );
}
